module.exports = __webpack_public_path__ + "static/media/icon.fef70957.svg";